const ProfileSetting = () => {
    return(
        <div>
            <div className="flex flex-row mt-8 justify-between px-7  items-center">
                <h1 className="font-normal text-slate-600">User Image</h1>
                <div className="flex flex-row h-12">
                    <input type="text" className="border w-[35vw] rounded-l-lg pl-4" placeholder="Choose file..." />
                    <div className="border border-slate-200 w-24 bg-orange-400 hover:bg-orange-600 cursor-pointer text-center justify-center rounded-r-lg pt-3">
                        <h1 className="text-white font-normal">Browse</h1>
                    </div>
                </div>
            </div>
            <div className="mt-16 px-10">
                <div className="flex flex-row h-12">
                    <div className="flex flex-row mr-10 items-center">
                        <h1 className="font-normal text-slate-600 mr-6">First Name</h1>
                        <input type="text" className="border w-[20vw] h-12 rounded-l-lg pl-4" placeholder="Mark" />
                    </div>
                    <div className="flex flex-row items-center">
                        <h1 className="font-normal text-slate-600 mr-5">Last Name</h1>
                        <input type="text" className="border w-[20vw] h-12 rounded-l-xl pl-4" placeholder="Doe" />
                    </div>
                </div>

                <div className="mt-10 pr-6">
                <div className="flex flex-row items-center mt-12 justify-between">
                        <h1 className="font-normal text-slate-600">Username</h1>
                        <input type="text" className="border w-[40vw] h-12 rounded-l-xl pl-4"  />
                </div>
                <div className="flex flex-row items-center justify-between mt-12">
                        <h1 className="font-normal text-slate-600">Email</h1>
                        <input type="text" className="border w-[40vw] h-12 rounded-l-xl pl-4" placeholder="markdoe.example@gmail.com" />
                </div>
                <div className="flex flex-row items-center mt-12 justify-between">
                        <h1 className="font-normal text-slate-600">Old Password</h1>
                        <input type="text" className="border w-[40vw] h-12 rounded-l-xl pl-4"  />
                </div>
                <div className="flex flex-row items-center mt-12 justify-between">
                        <h1 className="font-normal text-slate-600">New Password</h1>
                        <input type="text" className="border w-[40vw] h-12 rounded-l-xl pl-4" />
                </div>
                <div className="flex flex-row items-center justify-between mt-12">
                        <h1 className="font-normal text-slate-600">Confirm Password</h1>
                        <input type="text" className="border w-[40vw] h-12 rounded-l-xl pl-4" />
                </div>
                <div className="mt-12 justify-between flex flex-row">
                <div></div>
                    <button className="bg-orange-500 hover:bg-orange-700 rounded-lg mt-6 text-white font-bold py-2 px-4">Update Profile</button>
                </div>
                </div>
            </div>
        </div>
    )
}
export default ProfileSetting